import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import ArthaGateway from 'service/ArthaGateway';
import { Party, SaleOrder, Product, OrderItem, OrderDocument, ProductMaster, ProductStyle } from 'service';
import defaultImage from "../../assets/default.png"
import { faChevronLeft, faFile, faGripVertical, faTableCells, faTableList, faTrash, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import toast, { Toaster } from 'react-hot-toast';
import { FileUpload } from '../Widgets';

export const NewOrder = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isProductsLoading, setIsProductsLoading] = useState<boolean>(false);
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [screenMode, setScreenMode] = useState<string>("main-screen");
    const [party, setParty] = useState<Party>();
    const [productGroups, setProductGroups] = useState<any[]>([]);
    const [products, setProducts] = useState<ProductMaster[]>([]);
    const [productStyles, setProductStyles] = useState<ProductStyle[]>([]);
    const [styleGroups, setStyleGroups] = useState<any>({});
    const [productGroup, setProductGroup] = useState<any>();
    const [productName, setproductName] = useState<string>("");
    const [styleName, setStyleName] = useState<string>("");
    const [selectionMode, setSelectionMode] = useState<string>("table");
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [totalPages, setTotalPages] = useState<number>(5);
    const [orderItem, setOrderItem] = useState<OrderItem>();
    const [order, setOrder] = useState<SaleOrder>(new SaleOrder());
    const [isOrderSaving, setIsOrderSaving] = useState<boolean>(false);

    const navigate = useNavigate();
    const handleFocus = (event) => event.target.select();

    useEffect(() => {
        if (user.profile) {
            setParty(user.profile.profile);
            setIsLoading(false);
        }
    }, [user]);

    useEffect(() => {
        if (party) {
            order.shippingStateCode = party.billingStateCode;
            order.shippingAddress1 = party.billingAddress1;
            order.shippingAddress2 = party.billingAddress2;
            order.shippingCity = party.billingCity;
            order.shippingPinCode = party.billingPinCode;

            setOrder({ ...order, party: party });
            loadProductGroups();
        }
    }, [party]);

    useEffect(() => {
        loadProductMasters();
    }, [pageNumber]);

    useEffect(() => {
        loadPartyDetails();
        let value = localStorage.getItem("selectionMode");
        if (value) {
            setSelectionMode(value);
        }
    }, []);

    useEffect(() => {
        setProducts([]);
        if (pageNumber != 1) {
            setPageNumber(1);
        }
        else {
            loadProductMasters();
        }
    }, [productGroup, productName]);

    const loadProductMasters = () => {
        let value = sessionStorage.getItem("productMasters");
        if (value) {
            let data = JSON.parse(value);
            setProducts(data.entries);
            setTotalPages(data.totalPages);
            setIsProductsLoading(false);
        }
        else {
            setIsProductsLoading(true);
            ArthaGateway
                .getProductMasters(productGroup?.id, 0, productName, true)
                .then((data) => {
                    setProducts(data.entries);

                    if (screenMode === "main-screen" && order.items.length === 0) {
                        setScreenMode("select-product");
                    }
                    setTotalPages(data.totalPages);
                    sessionStorage.setItem("productMasters", JSON.stringify(data));
                    setIsProductsLoading(false);
                })
                .catch(error => {
                    console.log(error);
                    setIsLoading(false);
                });
        }
    }

    const loadProductGroups = () => {
        if (productGroups.length > 0) {
            return;
        }
        if (sessionStorage.getItem("catagories") === null) {
            ArthaGateway
                .getProductGroups()
                .then((data) => {
                    data = data.filter(g => g.id !== 999);
                    data.forEach(element => {
                        element.products = [];
                    });
                    data.unshift({ id: 0, name: "All" });
                    sessionStorage.setItem("catagories", JSON.stringify(data));
                    setProductGroups(data);
                    setProductGroup(data[0]);
                })
                .catch(error => {
                    console.log(error);
                    setIsLoading(false);
                });
        }
        else {
            let localData = sessionStorage.getItem("catagories");
            if (localData) {
                let catagories = JSON.parse(localData);
                setProductGroups(catagories);
                setProductGroup(catagories[0]);
            }
        }
    }

    const loadPartyDetails = () => {
    }

    const selectProductMaster = (product: ProductMaster) => {
        localStorage.setItem("selectionMode", selectionMode);
        ArthaGateway
            .getProductMaster(product.id)
            .then((data) => {
                if (data) {
                    let orderItem: OrderItem = new OrderItem();
                    orderItem.productMaster = data;
                    orderItem.quantity = 1;
                    orderItem.product = data.products[0];
                    orderItem.options = structuredClone(data.products[0].options);
                    setOrderItem(orderItem);
                    setScreenMode("select-size");

                    loadProductStyles(data.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const loadProductStyles = (productMasterId) => {
        if (productMasterId === undefined || productMasterId === null) {
            return;
        }
        ArthaGateway
            .getProductStyles(productMasterId)
            .then((data) => {
                setProductStyles(data);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        const styleGroups = groupStyles(productStyles.filter(s => s.name.toLowerCase().includes(styleName.toLowerCase())));
        setStyleGroups(styleGroups);
    }, [productStyles, styleName]);

    const selectProductMasterStyle = (style) => {
        setOrderItem(Object.assign(new OrderItem(), { ...orderItem, style: { ...style } }));
        setScreenMode("select-size");
    }

    const removeCartItem = (index) => {
        let items = order.items;
        items.splice(index, 1);
        calculateOrderTotal(order);
        setOrder({ ...order, items: items });
    }

    const addOrderItem = (item: OrderItem | undefined) => {
        if (item) {
            selectProductBasedOnOptions();

            let product = item.product;

            item.price = product.price;
            item.unitId = product.unitOfMeasureId;
            item.unit = product.unitOfMeasureCode;
            item.priceIncludesTax = product.priceIncludesTax;
            item.discountPercentage = product.discount;
            item.isDiscountInPercentage = product.isDiscountInPercentage;
            item.squareFeet = product.squareFeet;
            item.cgstTaxPercentage = product.cgstTax.percentage;
            item.sgstTaxPercentage = product.sgstTax.percentage;
            item.igstTaxPercentage = product.igstTax.percentage;

            order.items.push(item);

            setOrder({ ...order, items: [...order.items] });
            setScreenMode("main-screen");
        }
    }

    const incrementQuantity = (item) => {
        if (item) {
            item.quantity++;
            setOrder({ ...order });
        }
    }

    const decrementQuantity = (item) => {
        if (item) {
            item.quantity--;
            setOrder({ ...order });
        }
    }

    const selectProductBasedOnOptions = () => {
        // Validate required data
        if (!orderItem || !orderItem.productMaster || !orderItem.productMaster.products || !orderItem.options) {
            console.warn('Missing productMaster.products or currentItem.options');
            return;
        }

        const selectedOptions = orderItem.options;
        const products = orderItem.productMaster.products;

        // Find product that matches all selected options
        const matchingProduct = products.find(product => {
            // Validate product has options
            if (!product.options || product.options.length === 0) {
                return false;
            }

            // Check if all selected options match this product's options
            return Object.entries(selectedOptions).every(([optionName, selectedValue]) => {
                // Find the option in the product by name
                const productOption = product.options.find(opt => opt.name === selectedValue.name);

                // If option doesn't exist in product, it's not a match
                if (!productOption) {
                    return false;
                }

                // Compare values (handle different data types)
                if (productOption.value == null && selectedValue.value == null) return true;
                if (productOption.value == null || selectedValue.value == null) return false;

                // Convert both to strings for comparison (handles numbers, booleans, etc.)
                const productStr = productOption.value?.toString().trim().toLowerCase();
                const selectedStr = selectedValue.value?.toString().trim().toLowerCase();

                return productStr === selectedStr;
            });
        });

        if (matchingProduct) {
            orderItem.product = matchingProduct;
        } else {
            // fallback to the first product or handle error
            orderItem.product = products[0];
        }
    }

    const setCalculatedValues = (item: OrderItem, order: SaleOrder) => {
        let grossValue = (item.product.price * item.quantity);
        item.discount = 0;
        if (item.product.discount > 0) {
            item.discount = (grossValue) * (item.product.discount / 100);
        }
        item.taxableValue = grossValue - item.discount;
        let tax = item.taxableValue * (item.product?.cgstTax?.percentage + item.product?.sgstTax?.percentage / 100);
        item.cgstTax = (tax / 2);
        item.sgstTax = (tax / 2);
        item.igstTax = 0;
        item.netValue = item.taxableValue + item.cgstTax + item.sgstTax + item.igstTax;
    }

    const calculateOrderTotal = (order: SaleOrder) => {
        order.taxableValue = order.items.reduce((a, b) => a + b.taxableValue, 0);
        order.discount = order.items.reduce((a, b) => a + b.discount, 0);
        order.cgstTax = order.items.reduce((a, b) => a + b.cgstTax, 0);
        order.sgstTax = order.items.reduce((a, b) => a + b.sgstTax, 0);
        order.igstTax = order.items.reduce((a, b) => a + b.igstTax, 0);
        order.netValue = order.items.reduce((a, b) => a + b.netValue, 0);
        order.roundOff = order.netValue - Math.round(order.netValue);
        order.billAmount = Math.round(order.netValue);
    }

    const updateQuantity = (e, index) => {
        let quantity = e.target.value;
        if (e.target.value.length === 0) {
            quantity = 0;
        }
        let item = order.items[index];
        item.quantity = parseInt(quantity);
        setCalculatedValues(item, order);
        calculateOrderTotal(order);
        setOrder({ ...order, items: [...order.items] });
    }

    const updateOrderNotes = (e) => {
        setOrder({ ...order, notes: e.target.value });
    }

    const saveOrder = () => {
        if (order.items.length === 0) {
            toast('Please add products to the order', { position: 'bottom-center', className: 'btn bg-danger' });
            return;
        }

        if (isOrderSaving) {
            toast('Order is already being saved', { position: 'bottom-center', className: 'btn bg-warning' });
            return;
        }

        setIsOrderSaving(true);
        order.date = moment().format("YYYY-MM-DD");
        order.dueDate = moment().add(15, 'days').format("YYYY-MM-DD");
        order.series = "HEAD OFFICE";
        order.branch = { id: 1, name: "HEAD OFFICE", code: "HEAD OFFICE" };
        order.status = 1;
        ArthaGateway
            .saveOrder(order)
            .then((data) => {
                toast('Order saved successfully', { position: 'bottom-center', className: 'btn bg-success' });
                setIsOrderSaving(false);
                setTimeout(() => {
                    navigate("/order");
                }, 2000);
            })
            .catch(error => {
                console.log(error);
                setIsOrderSaving(false);
            });
    }

    const showConfirmOrder = () => {
        if (order.items.length === 0) {
            toast('Please add products to the order', { position: 'bottom-center', className: 'btn bg-danger' });
            return;
        }

        setScreenMode("confirm-order");
    }

    const handleOptionChange = (value, optionName) => {
        if (!orderItem) {
            return;
        }
        let currentOption = orderItem?.options.find(option => option.name === optionName);
        if (currentOption) {
            currentOption.value = value;
            setOrderItem({ ...orderItem, options: [...orderItem.options] });
        }
    }

    const getOptionValue = (optionName) => {
        let currentOption = orderItem?.options.find(option => option.name === optionName);
        return currentOption ? currentOption.value : null;
    }

    const getDisplayImage = (item) => {
        if (item.customImageUrl && item.customImageUrl.length > 0) {
            return item.customImageUrl;
        }
        if (item.style?.imageUrl) {
            return item.style.imageUrl;
        }
        if (item.productMaster?.imageUrl) {
            return item.productMaster.imageUrl;
        }
        // Return null if no image
        return null;
    };

    const groupStyles = (styles) => {
        return styles.reduce((groups, style) => {
            const key = style.groupName && style.groupName.trim().length > 0
                ? style.groupName
                : "Other Styles";
            if (!groups[key]) groups[key] = [];
            groups[key].push(style);
            return groups;
        }, {});
    };

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page page-new-order'>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <div><Toaster /></div>
                    {screenMode === "main-screen" &&
                        <div>
                            <div>
                                <h2>New Order</h2>
                            </div>
                            {order.party &&
                                <>
                                    {order.items &&
                                        <div className="row">
                                            <ul className="list-group list-group-sm cart-items">
                                                {order.items.length == 0 &&
                                                    <li>
                                                        <div className="alert alert-danger m-2" style={{ float: "right" }}>
                                                            Your cart is empty, Please select the products by clicking on the below button
                                                        </div>
                                                    </li>
                                                }
                                                <div className='row'>
                                                    {order.items.map((item, index) => (
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            <div className='card m-2'>
                                                                <div className='card-img text-center'>
                                                                    {getDisplayImage(item) && (
                                                                        <img src={getDisplayImage(item)} alt={item.productMaster.name} style={{ maxHeight: '200px' }} />
                                                                    )}
                                                                </div>
                                                                <div className='card-body p-2'>
                                                                    <h5 className='card-title'>{item.product.name}</h5>
                                                                    {(item.style || item.notes) && (
                                                                        <p className='card-text'>
                                                                            <>
                                                                                {item.style && (
                                                                                    <div>Style: <b>{item.style.name}</b></div>
                                                                                )}
                                                                                {item.notes && item.notes.length > 0 && (
                                                                                    <div>Notes: <b>{item.notes}</b></div>
                                                                                )}

                                                                            </>
                                                                        </p>
                                                                    )}
                                                                </div>
                                                                <div className='card-footer'>
                                                                    <button className='btn btn-dark btn-sm' onClick={() => removeCartItem(index)}>
                                                                        <FontAwesomeIcon icon={faTrash} className='me-2' />
                                                                        Remove
                                                                    </button>
                                                                    <div className="float-end">
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="me-2">
                                                                                Quantity:
                                                                            </div>
                                                                            <button
                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                onClick={() => decrementQuantity(item)} // Your decrement handler
                                                                                disabled={item.quantity <= 1}
                                                                                type="button"
                                                                            >
                                                                                <FontAwesomeIcon icon={faMinus} />
                                                                            </button>

                                                                            <div className="mx-2">
                                                                                <b>{item.quantity}</b>
                                                                            </div>

                                                                            <button
                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                onClick={() => incrementQuantity(item)} // Your increment handler
                                                                                type="button"
                                                                            >
                                                                                <FontAwesomeIcon icon={faPlus} />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </ul>
                                        </div>
                                    }
                                    <div className="row">
                                        <div className='col'>
                                            <div className="btn btn-dark btn-sm w-100 mt-2 mb-2" onClick={() => setScreenMode("select-product")}>
                                                <FontAwesomeIcon icon={faPlus} className='me-2' />
                                                Select Another Product
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='form-group'>
                                            <label>Notes</label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                value={order.notes}
                                                onChange={(e) => updateOrderNotes(e)}
                                                style={{ paddingTop: "1.5rem" }}>
                                            </textarea>
                                        </div>
                                    </div>
                                    {order.items.length > 0 &&
                                        <div className="row">
                                            <div className="col">
                                                <div className="btn btn-success btn-lg w-100 mt-3" title="Save" onClick={() => showConfirmOrder()}>Create Order</div>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    }
                    {screenMode === "select-product" &&
                        <>
                            {/*<div className='form-group'>
                                <label>Category</label>
                                <select
                                    className='form-control'
                                    value={productGroup?.id}
                                    onChange={(e) => setProductGroup(productGroups.find(d => d.id === parseInt(e.target.value)))}>
                                    {productGroups.map((Brand, index) => {
                                        return (
                                            <option key={index} value={Brand.id}>{Brand.name}</option>
                                        );
                                    })}
                                </select>
                            </div>*/}
                            <div className='form-group' style={{ marginBottom: "10px" }}>
                                <label>Name</label>
                                <input
                                    className='form-control'
                                    value={productName}
                                    onChange={(e) => setproductName(e.target.value)} />
                            </div>
                            <div className="products-holder">
                                <div className='row mt-0'>
                                    <div className="btn-group btn-group-toggle w-100 p-0" data-toggle="buttons">
                                        <div className={"btn " + ((selectionMode != "table") ? "btn-secondary" : "btn-dark") + " btn-sm w-50"} onClick={() => setSelectionMode("grid")}><FontAwesomeIcon icon={faGripVertical}></FontAwesomeIcon> </div>
                                        <div className={"btn " + ((selectionMode != "grid") ? "btn-secondary" : "btn-dark") + " btn-sm w-50"} onClick={() => setSelectionMode("table")}><FontAwesomeIcon icon={faTableList}></FontAwesomeIcon> </div>
                                    </div>
                                </div>
                                {selectionMode === "table" &&
                                    <div className="products row">
                                        <table className="table table-sm products-table px-2">
                                            <tbody>
                                                {products.map((product, index) => (
                                                    <tr key={index}>
                                                        <td className="px-2">{product.name}</td>
                                                        <td style={{ width: "120px", textAlign: "right", padding: 0 }}>
                                                            <div className="btn btn-dark btn-sm w-100 mt-auto" onClick={() => selectProductMaster(product)}>Select</div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                {selectionMode === "grid" &&
                                    <div className="products row">
                                        {products.map((product, index) => (
                                            <div key={index} className="col-12 col-md-6 col-lg-4">
                                                <div className="card mt-2">
                                                    <div className="card-img-top text-center">
                                                        <img src={(product?.imageUrl && product?.imageUrl.length > 0) ? product.imageUrl : defaultImage} alt="product" style={{ maxHeight: '250px' }} />
                                                    </div>
                                                    <div className="card-body d-flex flex-column">
                                                        <div className="card-title">{product.name}</div>
                                                        <div className="btn btn-dark btn-sm w-100 mt-auto" onClick={() => selectProductMaster(product)}>Select</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {(totalPages > pageNumber) &&
                                    <>
                                        {isProductsLoading &&
                                            <div className="btn btn-dark w-100 text-center m-4">
                                                <div className="spinner-border text-light" role="status">
                                                </div>
                                            </div>
                                        }
                                        {!isProductsLoading &&
                                            <div className="btn btn-dark w-100 text-center mt-4" onClick={() => setPageNumber(pageNumber + 1)}>Load More...</div>
                                        }
                                    </>
                                }
                            </div>
                            <div className='btn btn-danger back-to-home' onClick={() => setScreenMode("main-screen")}>
                                <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: 10 }} />
                            </div>
                        </>
                    }
                    {screenMode === "select-size" &&
                        <>
                            <div className='row'>
                                <div className='col-12 text-center font-bold'>
                                    <h2>{orderItem?.productMaster?.name}</h2>
                                </div>
                            </div>
                            {orderItem && orderItem.productMaster.options && orderItem.productMaster.options.length > 0 &&
                                <div className="row">
                                    {orderItem.productMaster.options.map((option, index) => (
                                        <div className="col-6 col-md-4 mb-2" key={index}>
                                            <label>{option.name}</label>
                                            <select className="form-select" aria-label="Select Size" value={getOptionValue(option.name)} onChange={(e) => handleOptionChange(e.target.value, option.name)}>
                                                {option?.values?.map((value, index) => (
                                                    <option key={index} value={value}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    ))}
                                </div>
                            }
                            {/* Product Style Section */}
                            {productStyles.length > 0 && !orderItem?.customImageUrl &&
                                <>
                                    {orderItem?.style && (
                                        <div className="row">
                                            <div className="col-12 text-center">
                                                <img
                                                    src={orderItem.style.imageUrl?.length > 0
                                                        ? `${orderItem.style.imageUrl}`
                                                        : defaultImage
                                                    }
                                                    alt="style"
                                                    style={{ maxHeight: '250px' }}
                                                />
                                                <div><b>{orderItem.style.name}</b></div>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger mt-2"
                                                    onClick={() => setOrderItem(Object.assign(new OrderItem(), { ...orderItem, style: undefined }))}
                                                >Remove Style</button>
                                            </div>
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-12">
                                            <button
                                                type="button"
                                                className="btn btn-dark w-100 my-2"
                                                onClick={() => setScreenMode("select-style")}
                                            >Select Style</button>
                                        </div>
                                    </div>
                                </>
                            }

                            {/* Custom Style Section */}
                            {orderItem?.customImageUrl &&
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <img
                                            src={orderItem.customImageUrl}
                                            alt="Custom style"
                                            style={{ maxHeight: '250px' }}
                                        />
                                        <div><b>Custom Style</b></div>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger mt-2"
                                            onClick={() => setOrderItem(Object.assign(new OrderItem(), { ...orderItem, customImageUrl: "" }))}
                                        >Remove Custom Style</button>
                                    </div>
                                </div>
                            }

                            {/* File Upload Section */}
                            {orderItem && !orderItem.customImageUrl && !orderItem?.style?.imageUrl && (
                                <div className="row">
                                    <div className="col-12">
                                        <FileUpload
                                            buttonName="Upload Custom Style"
                                            folder="public/product/style/custom"
                                            onFileUpload={fileUrl =>
                                                setOrderItem(Object.assign(new OrderItem(), { ...orderItem, customImageUrl: fileUrl }))
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className='col-12 my-2'>
                                    <label className="w-100 text-center">Quantity</label>
                                    <div className="d-flex align-items-center">
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => {
                                                if (orderItem) {
                                                    setOrderItem(Object.assign(new OrderItem(), { ...orderItem, quantity: orderItem.quantity - 1 }));
                                                }
                                            }} // Your decrement handler
                                            disabled={(orderItem?.quantity || 1) <= 1}
                                            type="button"
                                        >
                                            <FontAwesomeIcon icon={faMinus} />
                                        </button>

                                        <div className="mx-2">
                                            <input
                                                type="number"
                                                className="form-control text-center"
                                                style={{ fontSize: "2rem" }}
                                                min={1}
                                                value={orderItem?.quantity || 1}
                                                onChange={(e) => {
                                                    if (orderItem) {
                                                        setOrderItem(Object.assign(new OrderItem(), { ...orderItem, quantity: Number(e.target.value) }));
                                                    }
                                                }}
                                            />
                                        </div>

                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => {
                                                if (orderItem) {
                                                    setOrderItem(Object.assign(new OrderItem(), { ...orderItem, quantity: orderItem.quantity + 1 }));
                                                }
                                            }} // Your increment handler
                                            type="button"
                                        >
                                            <FontAwesomeIcon icon={faPlus} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <label>Notes</label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={orderItem?.notes || ""}
                                        onChange={(e) => {
                                            if (orderItem) {
                                                setOrderItem(Object.assign(new OrderItem(), { ...orderItem, notes: e.target.value }));
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="btn btn-dark w-100 mt-4" onClick={() => addOrderItem(orderItem)}>Add to Order</div>
                                </div>
                            </div>
                            <div className='btn btn-danger back-to-home' onClick={() => setScreenMode("main-screen")}>
                                <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: 10 }} />
                            </div>
                        </>
                    }
                    {screenMode === "select-style" &&
                        <>
                            <div className='row'>
                                <div className='col-12 text-center font-bold'>
                                    <h2>{orderItem?.productMaster?.name}</h2>
                                </div>
                            </div>
                            <div className='form-group' style={{ marginBottom: "10px" }}>
                                <label>Style</label>
                                <input
                                    className='form-control'
                                    value={styleName}
                                    onChange={(e) => setStyleName(e.target.value)} />
                            </div>
                            <div className="styles-holder">
                                <div className="accordion" id="stylesAccordion">
                                    {Object.keys(styleGroups).map((group, idx) => (
                                        <div className="accordion-item" key={group}>
                                            <h2 className="accordion-header" id={`heading-${idx}`}>
                                                <button
                                                    className={`accordion-button ${idx !== 0 ? "collapsed" : ""}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse-${idx}`}
                                                    aria-expanded={"false"}
                                                    aria-controls={`collapse-${idx}`}>
                                                    {group} ({styleGroups[group].length})
                                                </button>
                                            </h2>
                                            <div
                                                id={`collapse-${idx}`}
                                                className={`accordion-collapse collapse`}
                                                aria-labelledby={`heading-${idx}`}
                                                data-bs-parent="#stylesAccordion">
                                                <div className="accordion-body p-2">
                                                    <div className="row justify-content-center">
                                                        {styleGroups[group].map((style, index) => (
                                                            <div key={index} className="col-6 col-md-6 col-lg-4 mb-2">
                                                                <div className="card">
                                                                    <div className="card-img-top text-center">
                                                                        <img
                                                                            src={style?.imageUrl && style.imageUrl.length > 0 ? style.imageUrl : defaultImage}
                                                                            alt="style"
                                                                            className='img-fluid'
                                                                        />
                                                                    </div>
                                                                    <div className="card-body d-flex flex-column p-1 text-center justify-content-center">
                                                                        <div className="card-title m-0">{style.name}</div>
                                                                        <div
                                                                            className="btn btn-dark btn-sm w-100 mt-auto"
                                                                            onClick={() => selectProductMasterStyle(style)}>
                                                                            Select
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className='btn btn-danger back-to-home' onClick={() => setScreenMode("select-size")}>
                                <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: 10 }} />
                            </div>
                        </>
                    }
                    {screenMode === "confirm-order" &&
                        <div>
                            <div className="row">
                                <div className="col">
                                    <div className="card mb-2 bg-primary text-white">
                                        <div className='card-header'>
                                            <h2>{order.party.name}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {order.items &&
                                <div className="row">
                                    <div className="col-12">
                                        <table className="table table-sm">
                                            <tbody>
                                                {order.items.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {item.product.name}
                                                            {item.style && <>
                                                                <br />Style: <b>{item.style?.name}</b>
                                                            </>}
                                                            {item.notes && item.notes.length > 0 && <>
                                                                <br />Notes: <b>{item.notes}</b>
                                                            </>}
                                                        </td>
                                                        <td style={{ textAlign: 'right', fontWeight: 'bolder', width: "100px", fontSize: "2rem", paddingRight: 10 }}>
                                                            {item.quantity}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                            {order.notes && order.notes.length > 0 &&
                                <div className="row">
                                    <div className="alert alert-secondary">
                                        <b>Notes:</b><br />
                                        {order.notes}
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col">
                                    {isOrderSaving &&
                                        <div className='btn btn-secondary btn-lg w-100 mb-2 mt-2' title="Saving Order">
                                            <div className="spinner-border text-light" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    }
                                    {!isOrderSaving &&
                                        <div className="btn btn-success btn-lg w-100 mb-2 mt-2" title="Save" onClick={() => saveOrder()}>Confirm Order</div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="btn btn-sm btn-danger w-100" title="Back" onClick={() => setScreenMode("main-screen")}>Back</div>
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
        </div>
    );
};